export interface PostAuthLandingRoleFlags {
  isSuperAdmin: boolean;
  isBusinessAdmin: boolean;
  isStaff: boolean;
}

import type { ExperienceMode } from '@/modules/account-context/core/accountContext';

export type LandingExperienceMode = ExperienceMode;

interface RoleLike {
  role: string;
}

export function getPostAuthLandingPath(flags: PostAuthLandingRoleFlags): '/dashboard' | '/book' {
  if (flags.isSuperAdmin || flags.isBusinessAdmin || flags.isStaff) {
    return '/dashboard';
  }

  return '/book';
}

export function getPostAuthLandingPathFromRoles(roles: RoleLike[]): '/dashboard' | '/book' {
  return getPostAuthLandingPath({
    isSuperAdmin: roles.some((role) => role.role === 'super_admin'),
    isBusinessAdmin: roles.some((role) => role.role === 'business_admin'),
    isStaff: roles.some((role) => role.role === 'staff'),
  });
}

export function getDefaultLandingPathForMode(mode: LandingExperienceMode): '/dashboard' | '/book' {
  return mode === 'player' ? '/book' : '/dashboard';
}

